$(document).ready(function() {
    $(".share_facebook").on("click", function() {
        window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
        return false;
    });

    $(".share_twitter").on("click", function() {
        window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=500,width=600');
        return false;
    });

    var linkToolTipIsActive = false;

    $(".share_link").on("click", function() {
        if (linkToolTipIsActive) return false;

        var button = this;
        var container = $(this).closest("ul")[0];
        var containerClassName = container.className;

        linkToolTipIsActive = true;

        function fallbackCopyTextToClipboard(text) {
            var textArea = document.createElement("textarea");
            textArea.value = text;
            textArea.className = "temp_textarea";
            textArea.style.opacity = 0;

            $("a.share_link").append(textArea);

            textArea.focus();
            textArea.select();

            try {
                var successful = document.execCommand('copy');
                var msg = successful ? null : 'unsuccessful';
                displayToolTip(msg);
            } catch (err) {
                displayToolTip(err);
            }

            $("textarea.temp_textarea").remove();
        }

        function copyTextToClipboard(text) {
            if (!navigator.clipboard) {
                fallbackCopyTextToClipboard(text);
                return;
            }

            navigator.clipboard.writeText(text).then(function() {
                displayToolTip();
            }, function(err) {
                displayToolTip(err);
            });
        }

        function displayToolTip(err) {
            var toolTip = document.createElement("div");
            var dataset = button.dataset;
            var text = err ? dataset.failed : dataset.succeeded;

            toolTip.innerHTML = text;
            toolTip.className = "copy_tool_tip";
            toolTip.style.display = "none";

            var position;
            var offset;

            if (containerClassName.indexOf("social_media_small") > -1) {
                position = 'left';
                offset = 15;
                $(container).prepend(toolTip);
            } else {
                position = 'right';
                offset = 10;
                $(container).append(toolTip);
            }

            var toolTipWidth = $(toolTip).outerWidth();
            toolTip.style[position] = -toolTipWidth - offset + "px";

            $(".copy_tool_tip").fadeIn(300);
            setTimeout(function() {
                $(".copy_tool_tip")
                    .fadeOut(300, function() {
                        $(".copy_tool_tip").remove();
                        linkToolTipIsActive = false;
                    });
            }, 3000);
        }

        copyTextToClipboard(this.href);
        return false;
    })
});
